import { createContext, useContext } from 'react';
import type { ScheduleSendModalState } from 'src/pages/Conversations/Chat/InputField/hooks/use-schedule-send-modal-state';
import type { SendAndCommand } from 'src/pages/Conversations/Chat/InputField/smart-send/send-and-commands';

export interface SmartSendConflict {
  scheduledLabel: string;
  previewText: string;
  onEditExisting: () => void;
  onReplaceWithNew: () => void;
}

export interface SmartSendContextValue {
  schedule: ScheduleSendModalState;
  sendAndCommands: SendAndCommand[];
  isProcessingOption: boolean;
  isOnline: boolean;
  conflict?: SmartSendConflict;
  selectSendAnd: (optionId: string) => void;
  save: () => void;
  close: () => void;
}

// Steps are pushed as elements whose props are fixed at push time, so they read the live
// schedule state from here instead.
export const SmartSendContext = createContext<SmartSendContextValue | null>(null);

export const useSmartSend = () => {
  const value = useContext(SmartSendContext);
  if (!value) {
    throw new Error('useSmartSend must be used inside SmartSendModal');
  }
  return value;
};
